import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { FinanzenPeriod } from '../intern/finanzen/components/period.util'

function defaultPeriod(): FinanzenPeriod {
  const now = new Date()
  const to = formatYearMonth(now)
  const fromDate = new Date(now.getFullYear(), now.getMonth() - 11, 1)
  return { from: formatYearMonth(fromDate), to }
}

function formatYearMonth(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

export interface FinanzenPageStateModel {
  period: FinanzenPeriod
}

export class FinanzenPageStateSetPeriod {
  static readonly type = '[FinanzenPage] Set Period'
  constructor(public readonly period: FinanzenPeriod) {}
}

@Injectable()
@State<FinanzenPageStateModel>({
  name: 'finanzenPage',
  defaults: {
    period: defaultPeriod(),
  },
})
export class FinanzenPageState {
  @Selector()
  static period({ period }: FinanzenPageStateModel) {
    return period
  }

  @Action(FinanzenPageStateSetPeriod)
  setPeriod(ctx: StateContext<FinanzenPageStateModel>, action: FinanzenPageStateSetPeriod) {
    ctx.patchState({ period: action.period })
  }
}
